import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PerfilEstrutura } from '../models/perfil-estrutura';
import { MatPaginator, PageEvent, MatDialog } from '@angular/material';
import { PerfilEstruturaService } from '../services/perfil-estrutura.service';
import { UtilitarioService } from '../services/utilitario.service';
import { Router } from '@angular/router';
import { GlobalService } from '../services/global.service';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import swal from 'sweetalert2';
import { MaxPainelService } from '../services/max-painel.service';
import { MaxPainelModalComponent } from '../modals/max-painel-modal/max-painel-modal.component';

declare const $: any;

@Component({
  selector: 'app-perfil-estrutura',
  templateUrl: './perfil-estrutura.component.html',
  styleUrls: ['./perfil-estrutura.component.scss']
})
export class PerfilEstruturaComponent implements OnInit {

  perfisFiltrados: PerfilEstrutura[] = [];
  carregando = true;
  campoOrdenacao = 'orientacao';
  ordenarDesc = false;
  editavel = true;
  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [];
  itensPorPagina = 10;

  tipos: any[] = [{ id: 0, nome: 'Pedidos' }, { id: 1, nome: 'Integradores' }];
  tipoSelecionado = 0;

  orientacoes = [
    {
      id: 0,
      descricao: "Retrato"
    },
    {
      id: 1,
      descricao: "Paisagem"
    }
  ];

  orientacaoSelecionada = 0;
  maxPainelSelecionado;
  larguraModuloSelecionada;
  tamPerfilSelecionado;

  listaPerfis = [];
  listaTamPerfil = [];
  listaMaxPainel = [];
  listaLarguraModulo = [];

  selectedFile: File;

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  @ViewChild('filePerfil', { static: false }) filePerfil: ElementRef;

  constructor(
    private perfilEstruturaService: PerfilEstruturaService,
    private maxPainelService: MaxPainelService,
    private utilitarioService: UtilitarioService,
    private router: Router,
    private globalService: GlobalService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private dialog: MatDialog
  ) {
    if (this.router.getCurrentNavigation().extras.state) {
      this.tipoSelecionado = this.router.getCurrentNavigation().extras.state.tipo;
    }
  }

  ngOnInit() {
    // this.buscarPerfis();
    this.buscarListaPerfis();
    this.buscarListaMaxPainel();
  }

  buscarDescricaoOrientacao(orientacao: number): string {
    return this.orientacoes.find(p => p.id === orientacao).descricao;
  }

  ordena(campo) {

    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {

    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarPerfis();
    this.paginator.firstPage();
  }

  buscarListaMaxPainel() {
    this.carregandoService.mostra('buscarListaMaxPainel');

    this.maxPainelService.consultarLista().subscribe(
      list => {
        this.listaMaxPainel = list;
        this.carregandoService.esconde('buscarListaMaxPainel');
      },
      err => {
        this.carregandoService.esconde('buscarListaMaxPainel');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarListaPerfis() {
    this.carregandoService.mostra('buscarListaPerfis');

    this.perfilEstruturaService.consultarLista().subscribe(
      list => {
        this.listaPerfis = list;
        this.montarListaTamPerfil();
        this.montarListaLarguraModulo();
        this.carregandoService.esconde('buscarListaPerfis');
      },
      err => {
        this.carregandoService.esconde('buscarListaPerfis');
        this.notificacaoService.erro(err);
      }
    );
  }

  montarListaLarguraModulo() {
    this.listaLarguraModulo = this.listaPerfis.map((p: PerfilEstrutura) => ({ larguraModulo: p.larguraModulo }));
    this.listaLarguraModulo = [... new Set(this.listaLarguraModulo.map(p => p.larguraModulo))].map(p => ({larguraModulo: p}));
  }

  montarListaTamPerfil() {
    this.listaTamPerfil = this.listaPerfis.map((p: PerfilEstrutura) => ({ tamPerfil: p.tamPerfil }));
    this.listaTamPerfil = [... new Set(this.listaTamPerfil.map(p => p.tamPerfil))].map(p => ({tamPerfil: p}));
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
    this.filePerfil.nativeElement.value = null;
    this.importar();
  }

  abrirModalMaxPainel() {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(MaxPainelModalComponent, {
      width: largura > 830 ? '800px' : (($('body').width()).toString() + 'px'),
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((res) => {
      this.buscarListaMaxPainel();
    });
  }

  buscarPerfis() {
    if(
      this.maxPainelSelecionado === undefined ||
      this.tamPerfilSelecionado === undefined ||
      this.larguraModuloSelecionada === undefined
    ) return;

    this.carregandoService.mostra('buscaPerfis');
    this.carregando = true;

    this.paginacao.paginaAtual = 0; // buscando todos

    this.perfilEstruturaService.consultarPerfilEstruturaComPaginacao
      (this.maxPainelSelecionado, this.tamPerfilSelecionado, this.larguraModuloSelecionada, this.orientacaoSelecionada, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe(dados => {
        this.perfisFiltrados = dados.itens;

        this.listaDeItensPorPagina = this.utilitarioService.calculaItensPorPagina(dados.total);

        if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
          this.itensPorPagina = 10;
        }

        this.paginacao.total = dados.total;

        // this.mudaDePagina({ length: dados.total, pageIndex: 0, pageSize: this.itensPorPagina });

        this.carregando = false;
        this.carregandoService.esconde('buscaPerfis');
      }, (erro) => {
        this.carregandoService.esconde('buscaPerfis');
        this.notificacaoService.erro(erro);
      });


  }

  novoPerfil() {
    this.router.navigate(['/configuracoes/perfil-estrutura/novo'], { state: { tipo: this.tipoSelecionado } });
  }

  editarPerfil(perfil) {
    this.router.navigate(['/configuracoes/perfil-estrutura/editar', perfil.id], { state: { tipo: this.tipoSelecionado } });
  }

  excluirPerfil(perfil: PerfilEstrutura) {

    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente excluir o Perfil?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {

        this.carregandoService.mostra('excluiPerfil');
        this.perfilEstruturaService.excluir(perfil.id).subscribe(resp => {

          this.notificacaoService.sucesso('Perfil excluído com sucesso!!!');
          this.carregandoService.esconde('excluiPerfil');
          this.filtra();

        }, (erro) => {
          this.carregandoService.esconde('excluiPerfil');
          this.notificacaoService.erro(erro);
        });

      }
    });

  }

  mudaDePagina(pageEvent: PageEvent) {
    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarPerfis();
  }

  ngOnDestroy(): void {

  }

  exportar() {
    this.carregandoService.mostra('exportar');
    this.perfilEstruturaService.exportar(
      this.maxPainelSelecionado,
      this.tamPerfilSelecionado,
      this.larguraModuloSelecionada,
      this.orientacaoSelecionada
    ).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, 'PerfilEstrutura_Modelo.xlsx');
      this.carregandoService.esconde('exportar');
    }, (erro) => {
      this.carregandoService.esconde('exportar');
      this.notificacaoService.erro(erro);
    });
  }

  importar() {
    const dados = new FormData();
    dados.append('arquivo', this.selectedFile);
    this.carregandoService.mostra('importar');
    this.perfilEstruturaService.importar(dados).subscribe((resp) => {
      this.carregandoService.esconde('importar');
      this.notificacaoService.sucesso('Perfil importado com sucesso!!!');
      this.selectedFile = undefined;
      this.buscarPerfis();
      this.buscarListaPerfis();
    }, (erro) => {
      this.carregandoService.esconde('importar');
      this.notificacaoService.erro(erro);
    });
  }
}
